import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArrowUpIcon = (props: IconProps) => (
  <Icon w="32px" h="32px" viewBox="0 0 32 32" {...props}>
    <path d="m16 10.6667-8 8 1.88 1.88L16 14.44l6.12 6.1067 1.88-1.88-8-8Z" />
  </Icon>
);

export default memo(ArrowUpIcon);
